var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4da",
    fillRule: "evenodd",
    d: "M.806 11.434a2.66 2.66 0 0 0 1.937.806h3.07c.085 0 .153-.017.188-.069.051-.034.085-.102.102-.17.018-.086.018-.173.035-.224 0-.069 0-.154-.017-.257v-.189c0-.051-.018-.102-.018-.137a.3.3 0 0 0-.069-.085c-.033-.018-.068-.034-.085-.052s-.051-.017-.102-.017c-.052-.017-.087-.017-.121-.017H2.744c-.412 0-.772-.155-1.08-.446a1.53 1.53 0 0 1-.447-1.08V2.743c0-.412.155-.772.446-1.08a1.53 1.53 0 0 1 1.08-.446h3.07c.085 0 .153-.017.188-.068a.3.3 0 0 0 .102-.172c.018-.086.018-.171.035-.223 0-.068 0-.154-.017-.257V.31a.3.3 0 0 0-.103-.223A.28.28 0 0 0 5.812 0H2.743C1.99 0 1.337.274.806.806.275 1.354 0 1.988 0 2.76v6.72c0 .771.275 1.406.806 1.954m3.052-3.051c.12.12.257.189.428.189h4.286v2.742c0 .171.068.309.188.429s.258.188.429.188a.62.62 0 0 0 .429-.188l5.194-5.195a.59.59 0 0 0 .189-.428.58.58 0 0 0-.189-.428L9.618.497a.62.62 0 0 0-.43-.188.59.59 0 0 0-.428.188.58.58 0 0 0-.188.429v2.742H4.286a.59.59 0 0 0-.428.189.59.59 0 0 0-.189.428v3.67c0 .17.069.308.189.428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.73cd538758ea62f0c10c610d1ddd8517.svg";
export { ForwardRef as ReactComponent };